import Vue from 'vue'
import App from './app.vue'
import router from './router'
import plugins, { i18n } from '@/plugins'

import './registerServiceWorker'
import '@/styles/index.scss'

import 'animate.css/animate.min.css'

const options = { router, i18n, render: h => h(App) }

plugins.load()

Vue.config.productionTip = true

Vue.prototype.$bus = new Vue()

new Vue(options).$mount('#app')
